import {ChangeDetectionStrategy, Component, computed, input} from "@angular/core";
import {DokumentVersjonModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {LazyBildelastingDirektiv} from "web-ng2/delt/direktiver/lazyBildelasting/lazyBildelasting";
import {DokumentInformasjonTjeneste} from "felles-ng2/tjenester/DokumentInformasjonTjeneste";

const debug = initDebugger('DokumentForsidebildeKomponent');

/**
 * Dokument forsidebilde
 */
@Component({
    selector: 'dokument-forsidebilde',
    templateUrl: 'dokument-forsidebilde.html',
    styleUrl: 'dokument-forsidebilde.scss',
    imports: [
        LazyBildelastingDirektiv
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DokumentForsidebildeKomponent {

    dokumentversjon = input.required<DokumentVersjonModell>();
    informasjon = computed(() => this.dokumentInformasjon.dokumentinformasjon(this.dokumentversjon()))

    constructor(private dokumentInformasjon: DokumentInformasjonTjeneste) {
    }
}
